import { render } from "./SpaBookingSummary.vue?vue&type=template&id=e0d85314&scoped=true"
import script from "./SpaBookingSummary.vue?vue&type=script&lang=js"
export * from "./SpaBookingSummary.vue?vue&type=script&lang=js"

import "./SpaBookingSummary.vue?vue&type=style&index=0&id=e0d85314&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0d85314"]])

export default __exports__